export default function (bytes, i18n) {
  const sizes = [i18n.t('common.bytes'), i18n.t('common.kb'), i18n.t('common.mb'), i18n.t('common.gb'), i18n.t('common.tb')];
  if (bytes === 0) {
    return '0 ' + i18n.t('common.bytes');
  }

  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
}